// Generic data-fetching hook - replaces the useState/useEffect boilerplate
// that was copy-pasted across every page. Returns { data, loading, refetch }.
import { useEffect, useState, useCallback } from 'react'

export function useData<T>(fetcher: () => Promise<T>, deps: any[] = []) {
  const [data, setData] = useState<T | null>(null)
  const [loading, setLoading] = useState(true)

  const load = useCallback(() => {
    setLoading(true)
    fetcher()
      .then(result => { setData(result) })
      .catch(err => {
        // Don't strand the page on a spinner if a fetch fails. Pages that
        // care about specific errors should check `data` and render an
        // empty/error state. Logged so the failure isn't completely silent.
        console.error('useData fetcher failed:', err)
        setData(null)
      })
      .finally(() => { setLoading(false) })
  }, deps)

  useEffect(() => { load() }, [load])

  return { data, loading, refetch: load }
}
